module.exports = __webpack_public_path__ + "img/character0.cc0dc350.png";